import { render, staticRenderFns } from "./CSVUploader.vue?vue&type=template&id=25886cb8&scoped=true&"
import script from "./CSVUploader.vue?vue&type=script&lang=js&"
export * from "./CSVUploader.vue?vue&type=script&lang=js&"
import style0 from "./CSVUploader.vue?vue&type=style&index=0&id=25886cb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25886cb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
